import React from 'react';
import { SxProps } from '@mui/material';
import { SelectItem } from 'shared/types/selectItem';
import CustomSelect from 'shared/lib/components/controls/selects/customSelect';

export enum SortingValue {
  CREATING_DEC = 'creating[dec]',
  CREATING_INC = 'creating[inc]',
  UPDATING_DEC = 'updating[dec]',
  UPDATING_INC = 'updating[inc]',
  FAVORITING_DEC = 'favoriting[dec]',
  FAVORITING_INC = 'favoriting[inc]',
}

const sortSelectItems: SelectItem<SortingValue>[] = [
  { id: SortingValue.CREATING_DEC, name: 'Сначала новые' },
  { id: SortingValue.CREATING_INC, name: 'Сначала старые' },
  { id: SortingValue.UPDATING_DEC, name: 'Дата изменений: новые' },
  { id: SortingValue.UPDATING_INC, name: 'Дата изменений: старые' },
];

export const sortApiMap = {
  [SortingValue.CREATING_DEC]: { sort_add_time: 'DESC' },
  [SortingValue.CREATING_INC]: { sort_add_time: 'ASC' },
  [SortingValue.UPDATING_DEC]: { sort_change_time: 'DESC' },
  [SortingValue.UPDATING_INC]: { sort_change_time: 'ASC' },
  // MOCK
  [SortingValue.FAVORITING_DEC]: { sort_favorite_time: 'DESC' },
  [SortingValue.FAVORITING_INC]: { sort_favorite_time: 'ASC' },
} as const;

export type SortingControlProps = {
  value: SortingValue;
  onChange: (value: SortingValue) => void;
  sx?: SxProps;
};

export default function SortingControl({
  value,
  onChange,
  sx,
}: SortingControlProps) {
  return (
    <CustomSelect
      value={value}
      items={sortSelectItems}
      onChange={onChange}
      isEmptyItem={false}
      sx={sx}
    ></CustomSelect>
  );
}
